import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { CS_FONT, CS_WEIGHT, csTokens } from 'components/CallScribe/callScribeTheme';

const usePostCallReviewStyles = makeStyles((theme: Theme) => {
  const t = csTokens(theme);
  return {
    root: {
      position: 'absolute',
      inset: 0,
      isolation: 'isolate',
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
      minHeight: 0,
      background: t.bg,
      color: t.text,
      fontFamily: "'Nunito', sans-serif",
      textAlign: 'left',
    },
    head: {
      flex: '0 0 auto',
      display: 'flex',
      alignItems: 'flex-start',
      gap: 8,
      padding: '12px 8px 8px 16px',
      minWidth: 0,
    },
    titleBlock: {
      flex: '1 1 auto',
      minWidth: 0,
      paddingTop: 6,
    },
    title: {
      margin: 0,
      fontSize: 20,
      lineHeight: '26px',
      fontWeight: CS_WEIGHT.heavy,
      letterSpacing: '-0.01em',
      color: t.text,
    },
    subtitle: {
      ...CS_FONT.small,
      margin: '2px 0 0',
      color: t.text2,
      fontVariantNumeric: 'tabular-nums',
      overflowWrap: 'anywhere',
    },
    subtitlePart: {
      ...CS_FONT.small,
      whiteSpace: 'nowrap',
    },
    headChip: {
      flex: '0 0 auto',
      paddingTop: 11,
    },
    body: {
      flex: '1 1 auto',
      minHeight: 0,
      overflowY: 'auto',
      overscrollBehavior: 'contain',
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      padding: '4px 16px 16px',
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
    },
    loadingBlock: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
    },
    progressTrack: {
      height: 4,
      margin: '4px 0',
      borderRadius: 2,
      background: t.surface,
      overflow: 'hidden',
    },
    progressFill: {
      height: '100%',
      width: '100%',
      borderRadius: 2,
      background: t.info,
      transformOrigin: 'left center',
      transition: 'transform 250ms ease-out',
      '@media (prefers-reduced-motion: reduce)': {
        transition: 'none',
      },
    },
    ticketRow: {
      display: 'flex',
      alignItems: 'flex-end',
      gap: 8,
      minWidth: 0,
    },
    ticketField: {
      flex: '1 1 auto',
      maxWidth: 220,
    },
    ticketCheck: {
      minHeight: 48,
      marginTop: 0,
    },
    confirmedTicket: {
      ...CS_FONT.small,
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      fontWeight: CS_WEIGHT.strong,
      color: t.pos,
      '& svg': { fontSize: 16 },
    },
    ticketError: {
      ...CS_FONT.small,
      margin: 0,
      display: 'flex',
      alignItems: 'flex-start',
      gap: 6,
      color: t.neg,
      '& svg': { fontSize: 16, marginTop: 1, flex: '0 0 auto' },
    },
    subGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      paddingTop: 12,
      borderTop: `1px solid ${t.line}`,
    },
    autosaved: {
      ...CS_FONT.caption,
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      fontWeight: CS_WEIGHT.strong,
      color: t.pos,
      '& svg': { fontSize: 14 },
    },
    original: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      padding: '8px 12px',
      borderLeft: `3px solid ${t.lineStrong}`,
    },
    autoBar: {
      flex: '0 0 auto',
      display: 'flex',
      alignItems: 'flex-start',
      gap: 10,
      padding: '14px 16px 16px',
      borderTop: `1px solid ${t.line}`,
      background: t.bg,
      color: t.info,
      '& svg': { fontSize: 20, flex: '0 0 auto', marginTop: 1 },
    },
    autoText: {
      ...CS_FONT.small,
      margin: 0,
      color: t.text,
      '& strong': { fontWeight: CS_WEIGHT.heavy },
    },
    checks: {
      display: 'flex',
      flexDirection: 'column',
    },
    closingBar: {
      flex: '0 0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
      padding: '12px 16px 16px',
      borderTop: `1px solid ${t.line}`,
      background: t.bg,
      '& button': { marginTop: 0 },
    },
    closingText: {
      ...CS_FONT.small,
      fontWeight: CS_WEIGHT.strong,
      color: t.text2,
      fontVariantNumeric: 'tabular-nums',
    },
  };
});

export default usePostCallReviewStyles;
